<template>
    <tabs parent="company_services">
        <tab id="tariff_devices" name="Tariff devices" :href="url+'tariff_devices'" >
            <CompanyTariffDevices :tariffs="tariffs" :clients="clients" />
        </tab>

        <tab id="tariffs" name="Tariffs" :href="url+'tariffs'" >
            <CompanyTariffs :tariffs="tariffs" :clients="clients" @update="get_tariffs"/>
        </tab>

        <tab id="services" name="Services" :href="url+'services'" >
            <CompanyServices />
        </tab>
    </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import CompanyTariffDevices from './CompanyServices/CompanyTariffDevices.vue'
import CompanyTariffs from './CompanyServices/CompanyTariffs.vue'
import CompanyServices from './CompanyServices/CompanyServices.vue'


export default {
    name: 'CompanyServicesIndex',
    components:{
        Tab,
        Tabs,
        CompanyTariffDevices,
        CompanyServices,
        CompanyTariffs,
    },
    props: {
    },
    data () {
      return {
          tariffs: {},
          clients: {}
      }
    },
    computed: {
        url () { return '/company_services/' },
    },

    created () {
        this.get_tariffs()
        this.get_clients()
    },

    methods: {
        get_tariffs(){
            this.$http.v1.getCompanyTariffs((response) => {
                this.tariffs = response.data
            })
        },
        get_clients(){
            this.$http.v1.getClients((response) => {
                this.clients = response.data
            })
        }
    },
}
</script>
